import logo from "assets/images/brands/brand-main-sm.png";
import hLogo from "assets/images/brands/brand-main-sm.png";

export const clientName = "Markets Act";
export const developedBy = "Markets Act";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "Markets Act";
export const companyWebsite = "#";
export const privacyPolicyLink = "#";
export const clientAgreementLink = "#";
export const sidebarLogo = hLogo;
export const smLogo = logo;
export const mainLogo = hLogo;
export const footerLogo = logo;
